<template>
  <div>
    <v-dialog
      v-model="isShow"
      max-width="500"
    >
      <template v-slot:activator="{ on }">
        <v-tooltip
          top
          color="black"
          :activator="$refs.btn"
          :value="tooltip"
        >
          <span>{{ $t('eDocInternal.markAsCompleted') }}</span>
        </v-tooltip>

        <v-btn
          ref="btn"
          icon
          color="deep-orange"
          class="mr-2"
          v-on="on"
          @mouseover="tooltip = true"
          @mouseleave="tooltip = false"
        >
          <v-icon>
            {{ mdiFileCheckOutline }}
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">
          {{ $t('eDocInternal.markAsCompleted') }}
        </v-card-title>

        <v-card-text class="mt-4 black--text">
          <!--  <p>$如果有為這份公文進行回覆，可在此輸入相關的資料</p>
          <v-btn
            outlined
            @click="replyDialog = true"
          >
            新增回覆資料
          </v-btn>

          <br><br><br>
 -->
          <!-- <p>
            {{ $t('eDocInternal.archiveNotice') }}
          </p> -->
          <!-- <p>
            $如果因這份公文有生成文件，可在此上載
          </p> -->
          <v-btn
            v-if="canArchive"
            outlined
            @click="uploadFileDialog = true"
          >
            {{ $t('Box.uploadFile') }}
          </v-btn>

          <br><br>
          <v-simple-table v-if="archivedDocs && archivedDocs.length">
            <thead>
              <tr>
                <th>{{ $t('FileUploader.Filename') }}</th>
                <th>{{ $t('eDocInternal.archiveDoc.type') }}</th>
                <th>{{ $t('PublicServant.Obser') }}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="doc in archivedDocs"
                :key="doc.id"
              >
                <td>{{ doc.docName }} </td>
                <td>
                  {{ showDocType(doc) }}
                </td>
                <td>{{ doc.remark }}</td>
                <td>
                  <v-btn
                    icon
                    @click="downloadArchiveFile(doc)"
                  >
                    <v-icon
                      class="mr-1"
                    >
                      {{ mdiFileDownloadOutline }}
                    </v-icon>
                  </v-btn>

                  <v-btn
                    icon
                    @click="askWhetherDeleteFile(doc)"
                  >
                    <v-icon
                      class="mr-1"
                      color="red"
                    >
                      {{ mdiClose }}
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="isShow = false"
          >
            {{ $t('PublicServant.Action.Close') }}
          </v-btn>
          <v-btn
            :loading="closeProcessLoading"
            color="primary"
            @click="closeProcess"
          >
            {{ $t('eDocInternal.markAsCompleted') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--     <v-dialog
      v-model="replyDialog"
      max-width="500px"
    >
      <v-form ref="archiveReplyForm">
        <v-card>
          <v-card-title>
            {{ $t('eDocInternal.reply.add') }}
          </v-card-title>
          <v-card-text>
            <s-date-picker
              v-model="archiveForm.replyDate"
              label="回函日期"
            />
            <v-text-field
              v-model="archiveForm.replyNumber"
              label="回函編號"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click="replyDialog = false"
            >
              {{ $t('PublicServant.Action.Close') }}
            </v-btn>
            <v-btn
              color="primary"
              @click="saveReplyInfo"
            >
              {{ $t('PublicServant.Action.Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog> -->

    <v-dialog
      v-model="uploadFileDialog"
      max-width="500px"
    >
      <v-form
        ref="archiveDocForm"
      >
        <v-card>
          <v-card-title>
            {{ $t('Box.uploadFile') }}
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="archiveDocForm.dfArchiveDocTypeId"
              :items="archiveDocType"
              :item-text="$chPtField('chinName')"
              item-value="id"
              :label="$t('eDocInternal.archiveDoc.type')"
            />
            <v-text-field
              v-model="remark"
              :label="$t('PublicServant.Obser')"
            />
            <s-file-uploader-with-entity
              ref="archiveUploader"
              :post-url="uploadFileUrl"
              multiple
              :maximum="20"
              extensions=""
              accept=""
              :response.sync="attachDocResponse"
              :label="$t('Outbox.UploadDoc')"
              @uploadError="onUploadError"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click="uploadFileDialog = false"
            >
              {{ $t('PublicServant.Action.Close') }}
            </v-btn>
            <v-btn
              :loading="loading"
              color="primary"
              @click="saveArchiveDocument"
            >
              {{ $t('PublicServant.Action.Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <s-confirm-dialog
      v-model="showingConfirmDialog"
      :message="$t('TaskList.AttentionManagement.DeleteConfirmation')"
      :true-label="$t('ConfirmModal.OK')"
      :false-label="$t('Text.Cancel')"
      @confirm="deleteFile"
    />
  </div>
</template>

<script>
import { mdiRedo, mdiMessageText, mdiFileCheckOutline, mdiClose, mdiFileDownloadOutline } from '@mdi/js'
// import { mapState } from 'vuex'
// import VuetifyJetValidator from 'vuetify-jet-validator'
import { globalModule } from '@/store/moduleName'
import { DOC_FLOW_ACTION_TYPE } from '@/constant/constant'

// import { SEARCH_STAFF_RECORD_TYPE } from '@/constant/constant'
// import _ from 'lodash'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import docFlowApi from '@/api/eDocInternal/docFlow'
import { uploadMethod } from '@/mixins/uploadMethod'
// import SDatePicker from '@/components/SDatePicker'
import SFileUploaderWithEntity from '@/components/SFileUploaderWithEntity'
import SConfirmDialog from '@/components/SConfirmDialog'

// const validator = new VuetifyJetValidator()

export default {
  components: {
    // SDatePicker,
    SFileUploaderWithEntity,
    SConfirmDialog
  },
  mixins: [docFlowMethod, uploadMethod],
  props: {
    // processId: {
    //   type: Number,
    //   default: null
    // },
    edoc: {
      type: Object,
      default: null
    },
    docFlowStatus: {
      type: Array,
      default: function () {
        return []
      }
    },
    canArchive: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      mdiRedo: mdiRedo,
      mdiMessageText: mdiMessageText,
      mdiFileCheckOutline: mdiFileCheckOutline,
      mdiClose: mdiClose,
      mdiFileDownloadOutline: mdiFileDownloadOutline,
      isShow: false,
      tooltip: false,
      loading: false,
      closeProcessLoading: false,
      replyDialog: false,
      uploadFileDialog: false,
      archiveForm: {
        dfProcessId: null,
        replyDate: null,
        replyNumber: null,
        statusCode: 'A'
      },
      archiveDocForm:
      {
        dfProcessId: null,
        details: [],
        statusCode: 'A', // 狀態: A- 生效; D: 刪除
        dfArchiveDocTypeId: null // 文件類型
      },
      remark: null,
      attachDocResponse: [],
      archiveDocType: [],
      uploadFileUrl: null,
      archivedDocs: [],
      showingConfirmDialog: false,
      currentDoc: null
    }
  },
  computed: {

  },
  watch: {
  },
  async created () {
    // this.confirm = _.debounce(this.debounceConfirm, 1000, { leading: true, trailing: false })
    this.uploadFileUrl = docFlowApi.uploadFileUrl
    await docFlowApi.getArchiveDocType(resp => {
      this.archiveDocType = resp.data
    })
    this.getProcessArchiveDocument()
  },
  methods: {
    debounceConfirm: function () {
      this.isShow = false
    },

    saveReplyInfo () {
      this.archiveForm.dfProcessId = this.edoc.dfProcessId
      this.archiveForm.statusCode = DOC_FLOW_ACTION_TYPE.ADD
      docFlowApi.insertProcessArchive(this.archiveForm, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('eDocInternal.msg.saveSuccess'))
          // this.$refs.archiveReplyForm.reset()
        }
      })
    },

    saveArchiveDocument () {
      this.loading = true
      this.archiveDocForm.dfProcessId = this.edoc.dfProcessId
      this.archiveDocForm.statusCode = DOC_FLOW_ACTION_TYPE.ADD

      if (!this.archiveDocForm.dfArchiveDocTypeId) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('eDocInternal.archiveDoc.type')]))
        this.loading = false
        return false
      }
      if (this.attachDocResponse.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsUpload', [this.$t('Outbox.doc')]))
        this.loading = false
        return false
      }

      this.attachDocResponse.forEach(attach => {
        this.archiveDocForm.details.push({
          docCode: attach.response,
          docName: attach.name,
          remark: this.remark
        })
      })

      docFlowApi.insertProcessArchiveDoc(this.archiveDocForm, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('eDocInternal.msg.saveSuccess'))
          this.$refs.archiveDocForm.reset()
          this.$refs.archiveUploader.clearFile()
          this.getProcessArchiveDocument()
        }
        this.archiveDocForm.details = [] // set null to clear previous stored files
        this.loading = false
      })
    },

    closeProcess () {
      this.closeProcessLoading = true
      docFlowApi.closeProcess(this.edoc.dfProcessId, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.isShow = false
          // this.$store.dispatch(docFlowModule + '/getProcessList', { 'pageNum': this.pageNum, 'status': this.docFlowStatus, 'orderByKey': this.orderingProp, 'isContainPrefilledReceiverOnly': this.onlyShowSuggestAndReceiver, 'pageSize': this.pageSize, 'isContainPrefilledInsOnly': this.onlyShowSuggestAndReceiver })
          this.$emit('back')
        }
        this.closeProcessLoading = false
      }, this.edoc.statusCode)
    },

    async getProcessArchiveDocument () {
      await docFlowApi.getProcessArchiveDocument(this.edoc.dfProcessId, resp => {
        this.archivedDocs = resp.data
      })
    },

    showDocType (doc) {
      let docType = this.archiveDocType.find(e => e.id === doc.dfArchiveDocTypeId)
      return this.$chPtObjData('chinName', docType)
    },

    askWhetherDeleteFile (doc) {
      this.currentDoc = doc
      this.showingConfirmDialog = true
    },

    deleteFile () {
      docFlowApi.deleteProcessArchiveDocument(this.edoc.dfProcessId, this.currentDoc.docCode, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.getProcessArchiveDocument()
        }
      })
    },

    downloadArchiveFile (doc) {
      docFlowApi.downloadArchiveDocument(doc.docCode, this.edoc.dfProcessId, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          // let disposition = resp.headers['content-disposition']
          // let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          // link.setAttribute('download', filename)
          link.setAttribute('download', doc.docName)
          link.click()
          window.URL.revokeObjectURL(url)
        }
        this.genPdfBtnLoading = false
      })
    }

  }
}
</script>
